export const
	SEARCH_DATA = "SEARCH_DATA",
    FORME_DATA = "FORME_DATA",
    PDF_DIALOG = "PDF_DIALOG",
    NOTICE_MODAL = "NOTICE_MODAL",
    UP_LOAD_TABLE_DATA = "UP_LOAD_TABLE_DATA",
    UP_LOAD_TAB_TYPE = "UP_LOAD_TAB_TYPE",
    SET_PDF_LIST = "SET_PDF_LIST",
    SET_PDF_DATA = "SET_PDF_DATA",
    SET_LOGGED_IN = "SET_LOGGED_IN",
    SET_SELECT_DEBTOR = "SET_SELECT_DEBTOR",
    SET_SELECT_CONTACT = "SET_SELECT_CONTACT",
    SET_ITEM_DETAIL = "SET_ITEM_DETAIL",
    SET_RECEIVABLES_FILTER = "SET_RECEIVABLES_FILTER",

    // investor-exchange
    SET_CHECKED_ROWS_IN_EXCHANGE = "SET_CHECKED_ROWS_IN_EXCHANGE",
    CLEAR_CHECKED_ROWS_IN_EXCHANGE = "CLEAR_CHECKED_ROWS_IN_EXCHANGE",
	SET_ACTIVE_ACCOUNT = "SET_ACTIVE_ACCOUNT",

	// alfa
	SET_ALFA_CONFIG = "SET_ALFA_CONFIG",

    // investor
    SET_INVESTOR_ID = "SET_INVESTOR_ID",

    SET_DASHBOARD = "SET_DASHBOARD",
    SET_DASHBOARD_INFO = "SET_DASHBOARD_INFO",

	SET_REDIRECT = "SET_REDIRECT",
	CLEAR_REDIRECT = "CLEAR_REDIRECT",

	CURRENCY_EXCHANGE_RATES = "EXCHANGE_RATES",
	AUCTION_CONFIG = "AUCTION_CONFIG",

	// sign up
	CLEAR_SIGN_UP = "CLEAR_SIGN_UP",
	SET_SIGN_UP_REFERRER = "SET_SIGN_UP_REFERRER",
	SET_SIGN_UP_SETTINGS = "SET_SIGN_UP_SETTINGS",
	SET_SIGN_UP_REDIRECT = "SET_SIGN_UP_REDIRECT",
	SET_SIGN_UP_CREDENTIALS = "SET_SIGN_UP_CREDENTIALS",
	UPDATE_SIGN_UP_DATA = "UPDATE_SIGN_UP_DATA",
	SET_SIGN_UP_STEP_ACTIVE = "SET_SIGN_UP_STEP_ACTIVE",
	SET_SIGN_UP_STEP_COMPLETED = "SET_SIGN_UP_STEP_COMPLETED",

	// tabs
	SET_SESSION_ACTIVE_TAB = "SET_SESSION_ACTIVE_TAB",

	nouse = null; //占位用，在上面添加